export const parseFullName = (firstName, lastName) => {
  if (firstName && lastName) return `${firstName} ${lastName} `

  if (firstName) return firstName

  if (lastName) return lastName

  return ''
}

export const capitalize = (string) => (
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
)
